import React from 'react'
import styles from './styles.module.css'
import { EXPO_PROMO, isExpoPromoLive } from '../../../../lib/expoPromo'

// Banner at the top of /<region>/shop when an event discount code is active
// (auto-applied site-wide by lib/expoPromo, or a /discount/<code> link). The discount itself is
// the backend coupon, applied at checkout; this only tells the visitor it is on.
// Shown only while the event runs, never before it starts (even via the link).
const EVENT_CODES = {
  [EXPO_PROMO.code]: {
    title: 'Sim Racing Expo Frankfurt',
    headline: `${EXPO_PROMO.percent}% off everything`,
    isLive: isExpoPromoLive,
    validText: 'Valid 15 to 19 October. Applied automatically at checkout.',
    // The backend takes the % off the NORMAL price and keeps whichever price is
    // lower (ChargedOrderInfo.PERCENT_OFF_REGULAR_PRICE_CODES), so say so.
    saleText: 'Already on sale? You always get the bigger discount: a bundle that is 12% off goes to 15% off its normal price, and anything already more than 15% off keeps its sale price.',
  },
}

function DiscountInfo({ code }) {
  // While the site-wide expo promo runs, its banner shows for everyone from the
  // first render (the session code is only known after hydration, and waiting for
  // it made the banner pop in and push the grid down).
  const effectiveCode = isExpoPromoLive() ? EXPO_PROMO.code : code
  const event = effectiveCode ? EVENT_CODES[String(effectiveCode).toLowerCase()] : null
  if (!event || !event.isLive()) return null
  return (
    <div className={styles.banner} role="note">
      <span className={styles.eyebrow}>{event.title}</span>
      <p className={styles.headline}>{event.headline}</p>
      <p className={styles.detail}>{event.validText}</p>
      {event.saleText && <p className={styles.detail}>{event.saleText}</p>}
    </div>
  )
}

export default DiscountInfo
